export enum ErrorMessages {
  Common = 'Что-то пошло не так. Повторите попытку позже',
  NotFound = 'К сожалению, этой страницы нет\u00A0на\u00A0сайте',
  SuchUserNotRegisteredAsClient = 'Пользователь с указанным e-mail не зарегистрирован как клиент',
  SuchUserNotRegistered = 'Пользователь с указанным e-mail не зарегистрирован',
  AccountNotActivated = 'Ваш аккаунт ещё не активирован. Проверьте Ваш e-mail или повторно запросите письмо активации',
  UserWithSuchEmailAndPasswordNotFound = 'Пользователь с таким e-mail и паролем не найден',
  PasswordReset = 'На указанный e-mail выслан новый пароль от Личного кабинета клиента.',
}
